import { Record as ImmutableRecord, Map as ImmutableMap } from 'immutable';
import Action from 'automation-ui-action-features/records/Action';
import LogEventKeys from 'automation-ui-log-events/constants/LogEventKeys';
const defaultProps = {
  // ACTION_EXECUTION
  [LogEventKeys.ACTION_EXECUTION_INDEX]: undefined,
  [LogEventKeys.ACTION]: undefined,
  [LogEventKeys.ERROR_SUB_TYPE]: undefined,
  [LogEventKeys.ERROR_TYPE]: undefined,
  [LogEventKeys.EXECUTION_STATE]: undefined,
  [LogEventKeys.FAIL_SUB_TYPE]: undefined,
  [LogEventKeys.FAIL_TYPE]: undefined,
  [LogEventKeys.MESSAGE]: undefined,
  [LogEventKeys.NEXT_ACTION_ID]: undefined,
  [LogEventKeys.SKIP_REASON]: undefined,
  // ENROLLMENT
  [LogEventKeys.ENROLL_TYPE]: undefined,
  [LogEventKeys.ENROLLMENT_STATE]: undefined,
  [LogEventKeys.UNENROLL_TYPE]: undefined,
  // PRE_ENROLLMENT
  [LogEventKeys.FILTER_EVENT_TYPE]: undefined,
  [LogEventKeys.PRE_ENROLLMENT_ID]: undefined,
  [LogEventKeys.TRIGGER_ENROLL_TYPE]: undefined,
  // Shared
  [LogEventKeys.CONTEXT_MAP]: undefined,
  [LogEventKeys.ENROLLMENT_ID]: undefined,
  [LogEventKeys.FLOW_ID]: undefined,
  [LogEventKeys.FLOW_OBJECT_TYPE]: undefined,
  [LogEventKeys.ID]: undefined,
  [LogEventKeys.IDEMPOTENCY_ID]: undefined,
  [LogEventKeys.NOTIFICATION_TYPE]: undefined,
  [LogEventKeys.OBJECT_ID]: undefined,
  [LogEventKeys.OBJECT_TYPE_ID]: undefined,
  [LogEventKeys.PORTAL_ID]: undefined,
  [LogEventKeys.TIMESTAMP]: undefined,
  [LogEventKeys.TYPE]: undefined,
  [LogEventKeys.LOG_EVENT_MESSAGE]: undefined
};
export default class LogEvent extends ImmutableRecord(defaultProps, 'LogEvent') {
  constructor(options = defaultProps) {
    const propMap = ImmutableMap(options);
    const action = propMap.get(LogEventKeys.ACTION);
    super(action ? propMap.set(LogEventKeys.ACTION, new Action(action)) : propMap);
  }
}